import { Center } from "@mantine/core";
import { Button, Modal, Text } from "components";
import { IRootState } from "config/redux";
import { ServiceConstants } from "constant";
import { TFunction } from "i18next";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { CreditService } from "services";
import { CreditRequestAttachmentResponse } from "types";

const { REQUEST_CREDIT_ATTACHMENT_DELETE_ID, REQUEST_PENDING } = ServiceConstants;

interface AttachmentModalProps {
  item: CreditRequestAttachmentResponse;
  opened: boolean;
  onClose: () => void;
  t: TFunction;
}

const AttachmentDeleteModal = ({ item, opened, onClose, t }: AttachmentModalProps) => {
  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CREDIT_ATTACHMENT_DELETE_ID + item.id]);

  const deleteAttachment = useCallback(() => CreditService.creditAttachmentDelete(item.id), [item.id]);
  const isLoading = useMemo(() => serviceObject && serviceObject.status === REQUEST_PENDING, [serviceObject]);

  return (
    <Modal opened={opened} onClose={onClose} title={t('credit.documentation.delivered.delete.title')}>
      <Text ta={'center'} my={24}>{t('credit.documentation.delivered.delete.confirm')}</Text>
      <Center mt={32}>
        <Button onClick={deleteAttachment} disabled={isLoading}>
          <Text>{t('action.delete')}</Text>
        </Button>
      </Center>
    </Modal>
  )
}

export default AttachmentDeleteModal;